import {
  FETCH_USER_ROLES_FOR_ACCOUNT, FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED, FETCH_USER_ROLES_FOR_ACCOUNT_FAILED,
  FETCH_USER_ROLE, FETCH_USER_ROLE_SUCCEEDED, FETCH_USER_ROLE_FAILED,
  CREATE_USER_ROLE, CREATING_USER_ROLE_SUCCEEDED, CREATING_USER_ROLE_FAILED,
  UPDATE_USER_ROLE, UPDATING_USER_ROLE_SUCCEEDED, UPDATING_USER_ROLE_FAILED,
  DELETE_USER_ROLE, DELETING_USER_ROLE_SUCCEEDED, DELETING_USER_ROLE_FAILED
} from '../actions/actionTypes.jsx';


const initialState = {
  loading: false,
  items: [],
  userRole: {
    item: null,
    loading: false,
    creating: false,
    updating: false
  }
}

function userRolesReducer(state = initialState, action) {
  switch (action.type) {

    case FETCH_USER_ROLES_FOR_ACCOUNT:
      return Object.assign({}, state, {
        ...state,
        loading: true
      })
      
    case FETCH_USER_ROLES_FOR_ACCOUNT_SUCCEEDED:
      var records = action.payload;

      return Object.assign({}, state, {
        ...state,
        loading: false,
        items: records
      })

    case FETCH_USER_ROLE:
      var id = action.payload;

      return Object.assign({}, state, {
        ...state,
        userRole: {
          ...state.userRole,
          item: null,
          loading: true
        }
      });
    
    case FETCH_USER_ROLE_SUCCEEDED:

      return Object.assign({}, state, {
        ...state,
        userRole: {
          ...state.userRole,
          loading: false,
          item: action.payload
        }
      });

    case FETCH_USER_ROLE_FAILED: 
      return {
        ...state,
        userRole: {
          ...state.userRole,
          loading: false,
          error: action.payload
        }
      }

    case CREATE_USER_ROLE: 
      return {
        ...state,
        creating: true
      }

    case CREATING_USER_ROLE_SUCCEEDED: 
      var items = state.items || [];
      items = [...items, action.payload];

      return {
        ...state,
        creating: false,
        items: items,
        userRole: {
          ...state.userRole,
          item: action.payload
        }
      }
    
    case CREATING_USER_ROLE_FAILED:
      return {
        ...state,
        creating: false,
        error: action.payload
      }

    case UPDATE_USER_ROLE:
      return {
        ...state,
        userRole: {
          ...state.userRole,
          updating: true
        }
      }

    case UPDATING_USER_ROLE_SUCCEEDED: 

      var items = state.items.map(item => {
        if(item.id === action.payload.response.id) {
          return action.payload.response
        }

        return item;
      });

      return {
        ...state,
        items: items,
        userRole: {
          ...state.userRole,
          updating: false,
          item: action.payload.response
        }
      }

    case UPDATING_USER_ROLE_FAILED: 
      return {
        ...state,
        userRole: {
          ...state.userRole,
          updating: false,
          error: action.payload.error
        }
      }

    case DELETE_USER_ROLE: 
      return {
        ...state,
        deleting: true
      }
    
    case DELETING_USER_ROLE_SUCCEEDED: 
      var items = (state.items || []).filter(item => {
        return item.id !== action.payload.id;
      })

      return {
        ...state, 
        deleting: false,
        items: items
      }

    case DELETING_USER_ROLE_FAILED:
      return {
        ...state,
        deleting: false,
        error: action.payload
      }
    
    default:
      return state
  }
}

export { userRolesReducer };